import React from "react"
import { CallTypeFilter } from "./call-type-filter"
import { DateRangeFilter } from "./date-range-filter"
import { OperatorFilter } from "./operator-filter"
import { IntentDirectionFilter } from "./intent-direction-filter.tsx"
import { CriteriaFilter } from "./criteria-filter.tsx"
import { TextFilter } from "./text-filter.tsx"
import { DebugSampleFilter } from "./debug-sample-filter.tsx"

interface ReportFiltersProps {
  filters: any
  updateFilters: (updates: any) => void
  showCallTypeFilter?: boolean
  showOperatorFilter?: boolean
  showIntentDirectionFilter?: boolean
  showCriteriaFilter?: boolean
  showTextFilter?: boolean
  showDebugSampleFilter?: boolean
}

export const ReportFilters: React.FC<ReportFiltersProps> = ({
  filters,
  updateFilters,
  showCallTypeFilter,
  showOperatorFilter,
  showIntentDirectionFilter,
  showCriteriaFilter,
  showTextFilter,
  showDebugSampleFilter,
}) => {
  return (
    <fieldset className="flex flex-row gap-4 mb-4 border border-base-300 p-4 rounded-md">
      <legend className="text-lg font-medium">Фильтры</legend>
      <div className="flex-1">
        <div className="flex flex-row gap-4">
          {showOperatorFilter && (
            <OperatorFilter
              operatorId={filters.operatorId}
              onOperatorChange={operatorId => updateFilters({ operatorId })}
              departmentId={filters.departmentId}
            />
          )}
          {showCallTypeFilter && (
            <CallTypeFilter
              callTypeId={filters.callTypeId}
              onCallTypeChange={callTypeId => {
                console.log(1234, callTypeId)
                updateFilters({ callTypeId })
              }}
              operatorId={filters.operatorId}
              departmentId={filters.departmentId}
            />
          )}
          {showIntentDirectionFilter && (
            <IntentDirectionFilter
              intentDirection={filters.intentDirection}
              onIntentDirectionChange={intentDirection => updateFilters({ intentDirection })}
            />
          )}
          <DateRangeFilter
            startDate={filters.startDate}
            endDate={filters.endDate}
            onStartDateChange={startDate => updateFilters({ startDate })}
            onEndDateChange={endDate => updateFilters({ endDate })}
          />
          {showTextFilter && <TextFilter text={filters.text} onTextChange={text => updateFilters({ text })} />}
          {showDebugSampleFilter && (
            <DebugSampleFilter
              debugSample={filters.debugSample}
              onDebugSampleChange={debugSample => updateFilters({ debugSample })}
            />
          )}
          {showCriteriaFilter && (
            <CriteriaFilter
              selectedCriteria={filters.criteria}
              onCriteriaChange={criteria => updateFilters({ criteria })}
            />
          )}
        </div>
      </div>
    </fieldset>
  )
}
